<template src="./modal.component.html"></template>
<style src="./modal.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import {getScrollbarWidth} from '@/helpers';

export default Vue.extend({
  data() {
    return {};
  },
  mounted() {
    const width = getScrollbarWidth();
    document.body.style.setProperty('overflow', 'hidden');
    document.body.style.setProperty('padding-right', `${width}px`);
  },
  methods: {
    closeModal(event: Event) {
      if (event.currentTarget === event.target) {
        this.$emit('close');
      }
    },
    onAfterLeave() {
      if (document.querySelectorAll('div.modal').length <= 1) {
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
      }
    },
  },
});
</script>
